<div class="modal-header">
  <h3 class="modal-title">{{ titleModal }}</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">

    <ul class="nav nav-tabs" ngbNav #nav="ngbNav">
      <li [ngbNavItem]="1" class="nav-item">
        <a ngbNavLink class="nav-link active" aria-current="page">Resumen</a>
        <ng-template ngbNavContent>
          <!-- New section for summary and relevant data -->
          @if (summaryData) {
            <div class="summary-section mt-4">
              <!-- Progress (pending/processing): no es fallo; Error solo si backgroundprocess=failed -->
              @if (analysisProgress) {
                <div class="analysis-progress alert alert-info" role="status">
                  <button
                    type="button"
                    class="analysis-error-close"
                    aria-label="Cerrar"
                    (click)="dismissAnalysisProgress()">
                    <i class="fas fa-times"></i>
                  </button>
                  <strong>Análisis en curso</strong>
                  <div class="analysis-error-message">{{ analysisProgress }}</div>
                </div>
              }
              @if (analysisError) {
                <div class="analysis-error alert alert-danger" role="alert">
                  <button
                    type="button"
                    class="analysis-error-close"
                    aria-label="Cerrar"
                    (click)="dismissAnalysisError()">
                    <i class="fas fa-times"></i>
                  </button>
                  <strong>No se pudo completar el análisis.</strong>
                  <div class="analysis-error-message">{{ analysisError }}</div>
                </div>
              }
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="d-flex align-items-center">
                  <h2 class="mb-0 me-2">Análisis del estado del requerimiento</h2>
                  <span class="badge" class="label-generated-by-ai">
                    <svg viewBox="0 0 14 17" class="sparkles-black">
                      <path
                        d="M6.417 4.074c.096 0 .157-.061.178-.157.191-1.114.184-1.128 1.36-1.36.096-.02.157-.076.157-.178 0-.096-.061-.157-.157-.171-1.176-.219-1.155-.24-1.36-1.36-.02-.096-.082-.164-.178-.164-.096 0-.157.068-.178.164-.205 1.107-.177 1.12-1.36 1.36-.096.014-.157.075-.157.17 0 .103.061.158.164.179 1.169.225 1.162.232 1.353 1.36.02.096.082.157.178.157zM3.095 8.921c.15 0 .266-.11.287-.253.232-1.798.28-1.812 2.167-2.16a.276.276 0 00.246-.28c0-.15-.11-.267-.253-.28-1.873-.26-1.928-.315-2.16-2.154-.02-.15-.13-.26-.287-.26-.15 0-.26.11-.28.267-.22 1.798-.294 1.798-2.168 2.146-.15.02-.252.13-.252.28 0 .158.102.26.28.28 1.846.288 1.92.35 2.14 2.147.02.158.13.267.28.267zm4.82 7.54c.211 0 .375-.15.41-.376.498-3.67 1.01-4.252 4.655-4.662a.416.416 0 00.39-.41c0-.22-.165-.383-.39-.417-3.61-.431-4.123-.957-4.656-4.662-.04-.22-.198-.37-.41-.37-.212 0-.376.15-.41.37-.5 3.677-1.012 4.258-4.655 4.662-.226.027-.39.198-.39.417 0 .212.164.383.39.41 3.602.492 4.101.964 4.655 4.662.04.226.198.376.41.376z">
                      </path>
                    </svg>
                    Generado con IA
                  </span>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-ai-analysis"
                  (click)="generateAnalysis()"
                  [disabled]="analisys_submitted">
                  @if (analisys_submitted) {
                    <div>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Analizando...
                    </div>
                  }
                  @if (!analisys_submitted) {
                    <span>
                      <i class="fas fa-magic"></i>
                      {{ summaryData.summary ? 'Reanalizar con IA' : 'Analizar con IA' }}
                    </span>
                  }
                </button>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="summary-content">
                    <markdown [data]="summaryData.summary"></markdown>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <h2 class="mt-4 mb-3">Datos Relevantes</h2>
                <span class="badge" class="label-generated-by-ai">
                  <svg viewBox="0 0 14 17" class="sparkles-black">
                    <path
                      d="M6.417 4.074c.096 0 .157-.061.178-.157.191-1.114.184-1.128 1.36-1.36.096-.02.157-.076.157-.178 0-.096-.061-.157-.157-.171-1.176-.219-1.155-.24-1.36-1.36-.02-.096-.082-.164-.178-.164-.096 0-.157.068-.178.164-.205 1.107-.177 1.12-1.36 1.36-.096.014-.157.075-.157.17 0 .103.061.158.164.179 1.169.225 1.162.232 1.353 1.36.02.096.082.157.178.157zM3.095 8.921c.15 0 .266-.11.287-.253.232-1.798.28-1.812 2.167-2.16a.276.276 0 00.246-.28c0-.15-.11-.267-.253-.28-1.873-.26-1.928-.315-2.16-2.154-.02-.15-.13-.26-.287-.26-.15 0-.26.11-.28.267-.22 1.798-.294 1.798-2.168 2.146-.15.02-.252.13-.252.28 0 .158.102.26.28.28 1.846.288 1.92.35 2.14 2.147.02.158.13.267.28.267zm4.82 7.54c.211 0 .375-.15.41-.376.498-3.67 1.01-4.252 4.655-4.662a.416.416 0 00.39-.41c0-.22-.165-.383-.39-.417-3.61-.431-4.123-.957-4.656-4.662-.04-.22-.198-.37-.41-.37-.212 0-.376.15-.41.37-.5 3.677-1.012 4.258-4.655 4.662-.226.027-.39.198-.39.417 0 .212.164.383.39.41 3.602.492 4.101.964 4.655 4.662.04.226.198.376.41.376z">
                    </path>
                  </svg>
                  Generado con IA
                </span>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="relevant-data">
                    @for (item of summaryData.relevantData | keyvalue; track item) {
                      <div class="data-item">
                        <div class="data-name">{{ humanizeLabel(item.key) }}</div>
                        <div class="data-value">{{ humanizeData(item.value) }}</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </ng-template>
      </li>
      <li [ngbNavItem]="2" class="nav-item">
        <a ngbNavLink class="nav-link" aria-current="page">Preguntas</a>
        <ng-template ngbNavContent>
          <div class="d-flex align-items-center">
            <h2 class="mt-4 mb-3">Escribe tu pregunta y la IA te ayudará a analizar el requerimiento.</h2>
            <span class="badge" class="label-generated-by-ai">
              <svg viewBox="0 0 14 17" class="sparkles-black">
                <path
                  d="M6.417 4.074c.096 0 .157-.061.178-.157.191-1.114.184-1.128 1.36-1.36.096-.02.157-.076.157-.178 0-.096-.061-.157-.157-.171-1.176-.219-1.155-.24-1.36-1.36-.02-.096-.082-.164-.178-.164-.096 0-.157.068-.178.164-.205 1.107-.177 1.12-1.36 1.36-.096.014-.157.075-.157.17 0 .103.061.158.164.179 1.169.225 1.162.232 1.353 1.36.02.096.082.157.178.157zM3.095 8.921c.15 0 .266-.11.287-.253.232-1.798.28-1.812 2.167-2.16a.276.276 0 00.246-.28c0-.15-.11-.267-.253-.28-1.873-.26-1.928-.315-2.16-2.154-.02-.15-.13-.26-.287-.26-.15 0-.26.11-.28.267-.22 1.798-.294 1.798-2.168 2.146-.15.02-.252.13-.252.28 0 .158.102.26.28.28 1.846.288 1.92.35 2.14 2.147.02.158.13.267.28.267zm4.82 7.54c.211 0 .375-.15.41-.376.498-3.67 1.01-4.252 4.655-4.662a.416.416 0 00.39-.41c0-.22-.165-.383-.39-.417-3.61-.431-4.123-.957-4.656-4.662-.04-.22-.198-.37-.41-.37-.212 0-.376.15-.41.37-.5 3.677-1.012 4.258-4.655 4.662-.226.027-.39.198-.39.417 0 .212.164.383.39.41 3.602.492 4.101.964 4.655 4.662.04.226.198.376.41.376z">
                </path>
              </svg>
              Generado con IA
            </span>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="summary-content">
                <textarea
                  class="form-control style-textarea"
                  rows="3"
                  cols="40"
                  [(ngModel)]="prompt" >
                </textarea>
                <button type="button"
                  class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2 btn-ai-question"
                  style="width: 120px;"
                  (click)="send()"
                  [disabled]="submitted">
                  @if (submitted) {
                    <div>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Ejecutando...
                    </div>
                  }
                  @if (!submitted) {
                    <span>
                      Enviar
                    </span>
                  }
                </button>
                @if (promptResult.length > 0) {
                  <button type="button" class="btn btn-outline-primary btn-sm copy-button" (click)="copyToClipboard()">Copiar</button>
                }
                <span class="copy-tooltip">Copiado al portapapeles</span>
                @if (promptResult.length > 0) {
                  <div class="prompt-result">
                    <markdown
                      [data]="promptResult">
                    </markdown>
                  </div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>

  </div>
  <div class="form-group">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
          (click)="activeModal.close('Close click')">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
